module.exports = __webpack_public_path__ + "static/media/4.f3d52b86.png";